import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  announcedEvents?: Maybe<Array<AnnouncedEvent>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountAttributes = {
  boxOfficeProcessor?: InputMaybe<BoxOfficeProcessorEnum>;
  cartLockDuration?: InputMaybe<Scalars['Float']['input']>;
  feeStructureId?: InputMaybe<FeeStructureEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<UserAttributes>;
  whitelabelConfigId?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountConfig = {
  __typename?: 'AccountConfig';
  features: Array<AccountFeature>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountDetails = {
  __typename?: 'AccountDetails';
  boxOfficeProcessor: BoxOfficeProcessorEnum;
  cartLockDuration?: Maybe<Scalars['Float']['output']>;
  feeStructureId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  onboarded?: Maybe<Scalars['Boolean']['output']>;
  owner: User;
  whitelabelConfig?: Maybe<WhitelabelConfig>;
  whitelabelConfigId?: Maybe<Scalars['Int']['output']>;
};

/** AccountDetailsCollection type */
export type AccountDetailsCollection = {
  __typename?: 'AccountDetailsCollection';
  /** A collection of paginated AccountDetailsCollection */
  collection: Array<AccountDetails>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type AccountFeature = {
  __typename?: 'AccountFeature';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of AcquireLock */
export type AcquireLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of AcquireLock. */
export type AcquireLockPayload = {
  __typename?: 'AcquireLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  notABot?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddEventArtistMutation */
export type AddEventArtistMutationInput = {
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddEventArtistMutation. */
export type AddEventArtistMutationPayload = {
  __typename?: 'AddEventArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  eventArtist?: Maybe<EventArtist>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddEventGroupArtistMutation */
export type AddEventGroupArtistMutationInput = {
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventGroupId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddEventGroupArtistMutation. */
export type AddEventGroupArtistMutationPayload = {
  __typename?: 'AddEventGroupArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  eventGroupArtist?: Maybe<EventGroupArtist>;
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AddressAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Agent = {
  __typename?: 'Agent';
  agencyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Agreement = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type Allowance = {
  __typename?: 'Allowance';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AnnounceArtist = {
  __typename?: 'AnnounceArtist';
  accountId: Scalars['Int']['output'];
  applemusic?: Maybe<Scalars['String']['output']>;
  bandcamp?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  lastfm?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  songkick?: Maybe<Scalars['String']['output']>;
  spotify?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wikipedia?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type AnnounceArtistInput = {
  applemusic?: InputMaybe<Scalars['String']['input']>;
  bandcamp?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  lastfm?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  songkick?: InputMaybe<Scalars['String']['input']>;
  spotify?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wikipedia?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type AnnounceAttachment = {
  __typename?: 'AnnounceAttachment';
  attachment: Attachment;
  attachmentId: Scalars['Int']['output'];
  highlighted?: Maybe<Scalars['Boolean']['output']>;
};

export type AnnounceAttachmentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentId: Scalars['Int']['input'];
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnnounceDetail = {
  __typename?: 'AnnounceDetail';
  announceArtists?: Maybe<Array<AnnounceArtist>>;
  announceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use `artists` field instead */
  attachments?: Maybe<Array<AnnounceAttachment>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultTicketsUrl?: Maybe<Scalars['String']['output']>;
  defaultTicketsUrlNewTab?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventArtists?: Maybe<Array<EventArtist>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  highlightedImageIdx?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  onSaleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Array<TrackingEntry>>;
  triggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AnnounceDetailInput = {
  announce?: InputMaybe<Scalars['Boolean']['input']>;
  announceArtists?: InputMaybe<Array<AnnounceArtistInput>>;
  announceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  artists?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<AnnounceAttachmentInput>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  eventName: Scalars['String']['input'];
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  onSaleAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  promoter?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  ticketsUrl?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Array<TrackingAttributes>>;
  triggeredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AnnounceImage = {
  __typename?: 'AnnounceImage';
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  variants?: Maybe<Array<AnnounceImageVariant>>;
  /** @deprecated Use `variants` */
  versions?: Maybe<AnnounceImageVersions>;
};

export type AnnounceImageVariant = {
  __typename?: 'AnnounceImageVariant';
  src: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type AnnounceImageVersion = {
  __typename?: 'AnnounceImageVersion';
  src?: Maybe<Scalars['String']['output']>;
};

export type AnnounceImageVersions = {
  __typename?: 'AnnounceImageVersions';
  cover?: Maybe<AnnounceImageVersion>;
  thumb?: Maybe<AnnounceImageVersion>;
};

export type AnnouncedEvent = {
  __typename?: 'AnnouncedEvent';
  accountId?: Maybe<Scalars['Int']['output']>;
  announceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  announceName?: Maybe<Scalars['String']['output']>;
  artistName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventGroupId?: Maybe<Scalars['Int']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onSaleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
  venueRoomId?: Maybe<Scalars['Int']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type App = {
  __typename?: 'App';
  accountConfig?: Maybe<AccountConfig>;
  /** Get a paginated list of accounts */
  accounts?: Maybe<AccountDetailsCollection>;
  aggregatedEventSales: EventSalesAggregated;
  announceArtists?: Maybe<Array<AnnounceArtist>>;
  applicationConfiguration?: Maybe<AppConfig>;
  applicationConfigurations?: Maybe<AppConfigCollection>;
  artist: Artist;
  artists: Array<SearchResultArtist>;
  calendars?: Maybe<Array<Calendar>>;
  companies?: Maybe<Array<Company>>;
  contacts?: Maybe<Array<Contact>>;
  eventGroup?: Maybe<EventGroup>;
  eventGroupArtist: EventGroupArtist;
  eventGroupArtists: EventGroupArtistCollection;
  /** Returns list of found events */
  events?: Maybe<EventCollection>;
  inquiries?: Maybe<Array<Inquiry>>;
  /** Returns Looker Report link for user_account */
  lookerReportLink?: Maybe<Scalars['String']['output']>;
  /** Looker Report List */
  lookerReports: Array<Report>;
  order: Order;
  teamRoleDetails: TeamRoleDetails;
  teamRoles: Array<TeamRole>;
  ticketLayout?: Maybe<TicketLayout>;
  /** List of ticket layouts */
  ticketLayouts?: Maybe<TicketLayoutConnection>;
  userAccounts: UserAccountCollection;
  users?: Maybe<Array<User>>;
  venues?: Maybe<Array<Venue>>;
  /** Returns whitelabel configs */
  whitelabelConfigs?: Maybe<Array<WhitelabelConfig>>;
  widgetConfigurations: WidgetConfigCollection;
};


export type AppAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type AppAnnounceArtistsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type AppApplicationConfigurationArgs = {
  id: Scalars['Int']['input'];
};


export type AppApplicationConfigurationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type AppArtistArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AppArtistsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AppCalendarsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type AppCompaniesArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type AppContactsArgs = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
};


export type AppEventGroupArgs = {
  id: Scalars['Int']['input'];
};


export type AppEventGroupArtistArgs = {
  id: Scalars['ID']['input'];
};


export type AppEventGroupArtistsArgs = {
  eventGroupId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type AppEventsArgs = {
  filter?: InputMaybe<EventSearchArguments>;
  pagination?: InputMaybe<PaginationInput>;
};


export type AppInquiriesArgs = {
  inquiryId?: InputMaybe<Scalars['Int']['input']>;
};


export type AppLookerReportLinkArgs = {
  reportId: Scalars['String']['input'];
};


export type AppOrderArgs = {
  id: Scalars['Int']['input'];
};


export type AppTeamRoleDetailsArgs = {
  roleId: Scalars['Int']['input'];
};


export type AppTeamRolesArgs = {
  accountId: Scalars['Int']['input'];
};


export type AppTicketLayoutArgs = {
  id: Scalars['Int']['input'];
};


export type AppTicketLayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AppUserAccountsArgs = {
  accountId: Scalars['Int']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type AppUsersArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type AppWidgetConfigurationsArgs = {
  accountId: Scalars['Int']['input'];
};

export type AppConfig = {
  __typename?: 'AppConfig';
  appContext?: Maybe<AppConfigContextEnum>;
  applicationId?: Maybe<Scalars['String']['output']>;
  enforceOrigin?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  urlBase?: Maybe<Scalars['String']['output']>;
};

export type AppConfigAttributes = {
  appContext?: InputMaybe<AppConfigContextEnum>;
  enforceOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  urlBase?: InputMaybe<Scalars['String']['input']>;
};

/** AppConfigCollection type */
export type AppConfigCollection = {
  __typename?: 'AppConfigCollection';
  /** A collection of paginated AppConfigCollection */
  collection: Array<AppConfig>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export enum AppConfigContextEnum {
  App = 'APP',
  BoxOffice = 'BOX_OFFICE',
  Checkout = 'CHECKOUT',
  PublicApi = 'PUBLIC_API',
  Ticketbuyer = 'TICKETBUYER'
}

export type AppMutation = {
  __typename?: 'AppMutation';
  addEventArtist?: Maybe<AddEventArtistMutationPayload>;
  addEventGroupArtist?: Maybe<AddEventGroupArtistMutationPayload>;
  deleteAccount?: Maybe<DeleteAccountMutationPayload>;
  deleteTeamRole?: Maybe<DeleteTeamRoleMutationPayload>;
  deleteUserAccount?: Maybe<DeleteUserAccountMutationPayload>;
  deleteVenue?: Maybe<DeleteVenueMutationPayload>;
  deleteWhitelabelConfig?: Maybe<DeleteWhitelabelConfigMutationPayload>;
  deleteWidget?: Maybe<DeleteWidgetMutationPayload>;
  removeEventArtist?: Maybe<RemoveEventArtistMutationPayload>;
  removeEventGroupArtist?: Maybe<RemoveEventGroupArtistMutationPayload>;
  reorderEventArtists?: Maybe<ReorderEventArtistsMutationPayload>;
  resetPassword?: Maybe<ResetPasswordMutationPayload>;
  saveAccount?: Maybe<SaveAccountMutationPayload>;
  saveAppConfig?: Maybe<SaveAppConfigMutationPayload>;
  saveArtist?: Maybe<SaveArtistMutationPayload>;
  saveEvent?: Maybe<SaveEventMutationPayload>;
  saveEventArtistRider?: Maybe<SaveEventArtistRiderMutationPayload>;
  saveTeamRole?: Maybe<SaveTeamRoleMutationPayload>;
  saveTicketLayout?: Maybe<SaveTicketLayoutMutationPayload>;
  saveUser?: Maybe<SaveUserMutationPayload>;
  saveUserAccount?: Maybe<SaveUserAccountMutationPayload>;
  saveVenue?: Maybe<SaveVenueMutationPayload>;
  saveWhitelabelConfig?: Maybe<SaveWhitelabelConfigMutationPayload>;
  saveWidget?: Maybe<SaveWidgetConfigMutationPayload>;
  sendUserAccountInvitation?: Maybe<SendUserAccountInvitationMutationPayload>;
};


export type AppMutationAddEventArtistArgs = {
  input: AddEventArtistMutationInput;
};


export type AppMutationAddEventGroupArtistArgs = {
  input: AddEventGroupArtistMutationInput;
};


export type AppMutationDeleteAccountArgs = {
  input: DeleteAccountMutationInput;
};


export type AppMutationDeleteTeamRoleArgs = {
  input: DeleteTeamRoleMutationInput;
};


export type AppMutationDeleteUserAccountArgs = {
  input: DeleteUserAccountMutationInput;
};


export type AppMutationDeleteVenueArgs = {
  input: DeleteVenueMutationInput;
};


export type AppMutationDeleteWhitelabelConfigArgs = {
  input: DeleteWhitelabelConfigMutationInput;
};


export type AppMutationDeleteWidgetArgs = {
  input: DeleteWidgetMutationInput;
};


export type AppMutationRemoveEventArtistArgs = {
  input: RemoveEventArtistMutationInput;
};


export type AppMutationRemoveEventGroupArtistArgs = {
  input: RemoveEventGroupArtistMutationInput;
};


export type AppMutationReorderEventArtistsArgs = {
  input: ReorderEventArtistsMutationInput;
};


export type AppMutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};


export type AppMutationSaveAccountArgs = {
  input: SaveAccountMutationInput;
};


export type AppMutationSaveAppConfigArgs = {
  input: SaveAppConfigMutationInput;
};


export type AppMutationSaveArtistArgs = {
  input: SaveArtistMutationInput;
};


export type AppMutationSaveEventArgs = {
  input: SaveEventMutationInput;
};


export type AppMutationSaveEventArtistRiderArgs = {
  input: SaveEventArtistRiderMutationInput;
};


export type AppMutationSaveTeamRoleArgs = {
  input: SaveTeamRoleMutationInput;
};


export type AppMutationSaveTicketLayoutArgs = {
  input: SaveTicketLayoutMutationInput;
};


export type AppMutationSaveUserArgs = {
  input: SaveUserMutationInput;
};


export type AppMutationSaveUserAccountArgs = {
  input: SaveUserAccountMutationInput;
};


export type AppMutationSaveVenueArgs = {
  input: SaveVenueMutationInput;
};


export type AppMutationSaveWhitelabelConfigArgs = {
  input: SaveWhitelabelConfigMutationInput;
};


export type AppMutationSaveWidgetArgs = {
  input: SaveWidgetConfigMutationInput;
};


export type AppMutationSendUserAccountInvitationArgs = {
  input: SendUserAccountInvitationMutationInput;
};

/** Autogenerated input type of ApplyTemplate */
export type ApplyTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offerSheetId: Scalars['Int']['input'];
  templateId: Scalars['Int']['input'];
};

/** Autogenerated return type of ApplyTemplate. */
export type ApplyTemplatePayload = {
  __typename?: 'ApplyTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet: Sheet;
};

export type Artist = {
  __typename?: 'Artist';
  attachments?: Maybe<Array<ArtistAttachment>>;
  bio?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  links?: Maybe<Array<ArtistLink>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ArtistAttachment = {
  __typename?: 'ArtistAttachment';
  attachment: Attachment;
  attachmentId: Scalars['Int']['output'];
  highlighted?: Maybe<Scalars['Boolean']['output']>;
};

export type ArtistAttachmentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentId: Scalars['Int']['input'];
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArtistInput = {
  attachments?: InputMaybe<Array<ArtistAttachmentInput>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<Array<ArtistLinkInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformUrl?: InputMaybe<Scalars['String']['input']>;
  soundchartsUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistLink = {
  __typename?: 'ArtistLink';
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ArtistLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  accountId: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  derivedFromId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  status?: Maybe<AttachmentStatusEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  checksum: Scalars['String']['input'];
  derivedFromId?: InputMaybe<Scalars['ID']['input']>;
  mime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export enum AttachmentStatusEnum {
  Pending = 'PENDING',
  Ready = 'READY',
  Uploading = 'UPLOADING'
}

export enum BoxOfficeProcessorEnum {
  External = 'external',
  Stripe = 'stripe'
}

export type BreakdownItem = {
  __typename?: 'BreakdownItem';
  amount: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Calendar = {
  __typename?: 'Calendar';
  filterParams?: Maybe<FilterParams>;
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type CalendarInput = {
  filterParams: MutationFilterParams;
  id?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangeCustomerToken = {
  __typename?: 'ChangeCustomerToken';
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  availableTickets: Array<CheckoutTicketBlueprint>;
  /** Returns single sellable event details */
  event?: Maybe<CheckoutEvent>;
  orderSummary?: Maybe<OrderSummary>;
  shoppingCart: ShoppingCart;
};


export type CheckoutAvailableTicketsArgs = {
  shoppingCartToken?: InputMaybe<Scalars['String']['input']>;
};


export type CheckoutEventArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type CheckoutOrderSummaryArgs = {
  fingerprint: Scalars['String']['input'];
};


export type CheckoutShoppingCartArgs = {
  eventId: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutAlertMessage = {
  __typename?: 'CheckoutAlertMessage';
  messages?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CheckoutBlueprintPriceBreakdown = {
  __typename?: 'CheckoutBlueprintPriceBreakdown';
  ccFee: Scalars['Float']['output'];
  convenienceFee: Scalars['Float']['output'];
  displayPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  taxFee: Scalars['Float']['output'];
};

export type CheckoutCheckboxConfig = {
  __typename?: 'CheckoutCheckboxConfig';
  description?: Maybe<Scalars['String']['output']>;
  descriptionTitle?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type CheckoutConfig = {
  __typename?: 'CheckoutConfig';
  accessCode?: Maybe<Scalars['Boolean']['output']>;
  alerts?: Maybe<Array<CheckoutAlertMessage>>;
  checkboxes?: Maybe<Array<CheckoutCheckboxConfig>>;
  discount?: Maybe<Scalars['Boolean']['output']>;
  donation?: Maybe<Scalars['Boolean']['output']>;
  enableCaptcha?: Maybe<Scalars['Boolean']['output']>;
  eventId?: Maybe<Scalars['ID']['output']>;
  features?: Maybe<Array<CheckoutFeature>>;
  hiveBrandId?: Maybe<Scalars['String']['output']>;
  includeCcFee?: Maybe<Scalars['Boolean']['output']>;
  includeConvenienceFee?: Maybe<Scalars['Boolean']['output']>;
  includeTaxFee?: Maybe<Scalars['Boolean']['output']>;
  layloKey?: Maybe<Scalars['String']['output']>;
  paymentProcessor?: Maybe<Scalars['String']['output']>;
  processorAccountId: Scalars['String']['output'];
  processorPublicKey?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  quickCheckoutTos?: Maybe<CheckoutCheckboxConfig>;
  recaptchaCheckboxSiteKey?: Maybe<Scalars['String']['output']>;
  recaptchaCompleteOrderAction?: Maybe<Scalars['String']['output']>;
  recaptchaInvisibleSiteKey?: Maybe<Scalars['String']['output']>;
  recaptchaUpdateCartAction?: Maybe<Scalars['String']['output']>;
  requirePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  tracking?: Maybe<Array<TrackingEntry>>;
};

export type CheckoutCustomer = {
  __typename?: 'CheckoutCustomer';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Customer phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CheckoutEvent = {
  __typename?: 'CheckoutEvent';
  artists?: Maybe<Array<PublicAnnounceArtist>>;
  config: CheckoutConfig;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Array<AnnounceImage>>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  promoter?: Maybe<Scalars['String']['output']>;
  seatingChartConfig?: Maybe<SeatsioConfig>;
  slug?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  usesSeatingChart?: Maybe<Scalars['Boolean']['output']>;
  venue?: Maybe<PublicVenue>;
};

export type CheckoutFeature = {
  __typename?: 'CheckoutFeature';
  enabled: Scalars['Boolean']['output'];
  feature: Scalars['String']['output'];
};

export type CheckoutMutation = {
  __typename?: 'CheckoutMutation';
  acquireLock?: Maybe<AcquireLockPayload>;
  completeOrder?: Maybe<CompleteOrderPayload>;
  createPaymentInformation?: Maybe<CreatePaymentInformationPayload>;
  releaseLock?: Maybe<ReleaseLockPayload>;
  saveOrder?: Maybe<SaveOrderPayload>;
  updateOrderEmail?: Maybe<UpdateOrderEmailMutationPayload>;
  updatePaymentInformation?: Maybe<UpdatePaymentInformationPayload>;
  updateShoppingCart?: Maybe<UpdateShoppingCartPayload>;
  validateNotABot?: Maybe<ValidateNotABotPayload>;
};


export type CheckoutMutationAcquireLockArgs = {
  input: AcquireLockInput;
};


export type CheckoutMutationCompleteOrderArgs = {
  input: CompleteOrderInput;
};


export type CheckoutMutationCreatePaymentInformationArgs = {
  input: CreatePaymentInformationInput;
};


export type CheckoutMutationReleaseLockArgs = {
  input: ReleaseLockInput;
};


export type CheckoutMutationSaveOrderArgs = {
  input: SaveOrderInput;
};


export type CheckoutMutationUpdateOrderEmailArgs = {
  input: UpdateOrderEmailMutationInput;
};


export type CheckoutMutationUpdatePaymentInformationArgs = {
  input: UpdatePaymentInformationInput;
};


export type CheckoutMutationUpdateShoppingCartArgs = {
  input: UpdateShoppingCartInput;
};


export type CheckoutMutationValidateNotABotArgs = {
  input: ValidateNotABotInput;
};

export type CheckoutTicketBlueprint = {
  __typename?: 'CheckoutTicketBlueprint';
  breakdown?: Maybe<CheckoutBlueprintPriceBreakdown>;
  category?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  multiple?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use `displayPrice` from `breakdown` */
  price: Scalars['Float']['output'];
  soldOut: Scalars['Boolean']['output'];
  ticketType?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ChooseRefundOptionMutation */
export type ChooseRefundOptionMutationInput = {
  action: RefundActionEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};

/** Autogenerated return type of ChooseRefundOptionMutation. */
export type ChooseRefundOptionMutationPayload = {
  __typename?: 'ChooseRefundOptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<TicketbuyerOrder>;
};

/** Cognito configuration that can be fetched from the server. */
export type CognitoConfig = {
  __typename?: 'CognitoConfig';
  /** The client ID of the Cognito user pool. This client allows USER_PASSWORD_AUTH flow. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The region of the Cognito user pool. */
  region?: Maybe<Scalars['String']['output']>;
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  contacts?: Maybe<Array<Contact>>;
  description?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CompleteOrder */
export type CompleteOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderFingerprint: Scalars['String']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CompleteOrder. */
export type CompleteOrderPayload = {
  __typename?: 'CompleteOrderPayload';
  changeToken?: Maybe<ChangeCustomerToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

/** Global configuration that can be fetched from the server. */
export type Config = {
  __typename?: 'Config';
  /** Cognito configuration. */
  cognito?: Maybe<CognitoConfig>;
};

export type Contact = {
  __typename?: 'Contact';
  agencyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CreateAnnounceDetail */
export type CreateAnnounceDetailInput = {
  announceDetail: AnnounceDetailInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAnnounceDetail. */
export type CreateAnnounceDetailPayload = {
  __typename?: 'CreateAnnounceDetailPayload';
  announceDetail?: Maybe<AnnounceDetail>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of CreateAttachment */
export type CreateAttachmentInput = {
  attachment: AttachmentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAttachment. */
export type CreateAttachmentPayload = {
  __typename?: 'CreateAttachmentPayload';
  attachment?: Maybe<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateCalendar */
export type CreateCalendarInput = {
  calendar: CalendarInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCalendar. */
export type CreateCalendarPayload = {
  __typename?: 'CreateCalendarPayload';
  calendar?: Maybe<Calendar>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateCompany */
export type CreateCompanyInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  facebookUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCompany. */
export type CreateCompanyPayload = {
  __typename?: 'CreateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateInquiry */
export type CreateInquiryInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eventArtistId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInquiry. */
export type CreateInquiryPayload = {
  __typename?: 'CreateInquiryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  inquiry?: Maybe<Inquiry>;
};

/** Autogenerated input type of CreatePaymentInformation */
export type CreatePaymentInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePaymentInformation. */
export type CreatePaymentInformationPayload = {
  __typename?: 'CreatePaymentInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  paymentInformation?: Maybe<Array<PaymentInformation>>;
};

/** Autogenerated input type of CreateSheetVersion */
export type CreateSheetVersionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSheetVersion. */
export type CreateSheetVersionPayload = {
  __typename?: 'CreateSheetVersionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  version: SheetVersion;
};

/** Autogenerated input type of CreateTemplate */
export type CreateTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offerSheetId: Scalars['Int']['input'];
  templateName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTemplate. */
export type CreateTemplatePayload = {
  __typename?: 'CreateTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  template?: Maybe<Template>;
};

export type CustomExpense = {
  __typename?: 'CustomExpense';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deductedType?: Maybe<CustomExpenseDeductedTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  due?: Maybe<CustomExpenseDueEnum>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CustomExpenseAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  deductedType?: InputMaybe<CustomExpenseDeductedTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  due?: InputMaybe<CustomExpenseDueEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomExpenseDeductedTypeEnum {
  Gross = 'GROSS',
  Net = 'NET'
}

export enum CustomExpenseDueEnum {
  ToArtist = 'TO_ARTIST',
  ToVenue = 'TO_VENUE'
}

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String']['output'];
  emailOptedIn: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['BigInt']['output'];
  smsOptedIn: Scalars['Boolean']['output'];
};

export type CustomerInformationInput = {
  address: AddressInput;
  agreements?: InputMaybe<Array<Agreement>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customer: CustomerInput;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Deal = {
  __typename?: 'Deal';
  calculation: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  key: DealEnum;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DealAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED */
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealType?: InputMaybe<DealEnum>;
  expenseAmount?: InputMaybe<Scalars['Float']['input']>;
  firstAmount?: InputMaybe<Scalars['Float']['input']>;
  hitAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  showTicketSales?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DealEnum {
  /** Artist Guarantee */
  ArtistGuarantee = 'artist_guarantee',
  /** Artist Guarantee plus. GBOR after Expenses */
  ArtistGuaranteePlusGborAfterExpenses = 'artist_guarantee_plus_gbor_after_expenses',
  /** Artist Guarantee vs GBOR */
  ArtistGuaranteeVsGbor = 'artist_guarantee_vs_gbor',
  /** Artist Guarantee vs GBOR after Expenses */
  ArtistGuaranteeVsGborAfterExpenses = 'artist_guarantee_vs_gbor_after_expenses',
  /** Flat fee to artist */
  FlatFee = 'flat_fee',
  /** GBOR */
  Gbor = 'gbor',
  /** GBOR after expenses */
  GborAfterExpenses = 'gbor_after_expenses',
  /** Bar Guarantee due to Venue */
  GuaranteeToVenue = 'guarantee_to_venue',
  /** None */
  None = 'none',
  /** % of F&B sales if F&B exceeds amount after amount */
  PercentAfterHit = 'percent_after_hit',
  /** % of F&B sales if F&B exceeds amount */
  PercentWithHit = 'percent_with_hit',
  /** Rental fee to Venue */
  Rental = 'rental',
  /** % of F&B sales */
  SalesPercentage = 'sales_percentage'
}

/** Autogenerated input type of DeleteAccountMutation */
export type DeleteAccountMutationInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAccountMutation. */
export type DeleteAccountMutationPayload = {
  __typename?: 'DeleteAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteContact */
export type DeleteContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteContact. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DeleteExpenseCategory */
export type DeleteExpenseCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteExpenseCategory. */
export type DeleteExpenseCategoryPayload = {
  __typename?: 'DeleteExpenseCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteExpense */
export type DeleteExpenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteExpense. */
export type DeleteExpensePayload = {
  __typename?: 'DeleteExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteList */
export type DeleteListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteList. */
export type DeleteListPayload = {
  __typename?: 'DeleteListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteOfferContact */
export type DeleteOfferContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteOfferContact. */
export type DeleteOfferContactPayload = {
  __typename?: 'DeleteOfferContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<OfferSheetContact>>;
};

/** Autogenerated input type of DeleteTeamRoleMutation */
export type DeleteTeamRoleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamRoleId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTeamRoleMutation. */
export type DeleteTeamRoleMutationPayload = {
  __typename?: 'DeleteTeamRoleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTicket */
export type DeleteTicketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTicket. */
export type DeleteTicketPayload = {
  __typename?: 'DeleteTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteUserAccountMutation */
export type DeleteUserAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccountId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteUserAccountMutation. */
export type DeleteUserAccountMutationPayload = {
  __typename?: 'DeleteUserAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteVenueMutation */
export type DeleteVenueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenueMutation. */
export type DeleteVenueMutationPayload = {
  __typename?: 'DeleteVenueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteWhitelabelConfigMutation */
export type DeleteWhitelabelConfigMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteWhitelabelConfigMutation. */
export type DeleteWhitelabelConfigMutationPayload = {
  __typename?: 'DeleteWhitelabelConfigMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of DeleteWidgetMutation */
export type DeleteWidgetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteWidgetMutation. */
export type DeleteWidgetMutationPayload = {
  __typename?: 'DeleteWidgetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

export type Event = {
  __typename?: 'Event';
  announceDetail?: Maybe<AnnounceDetail>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  date: Scalars['ISO8601Date']['output'];
  /** Time (with date) in UTC, use event's timezone for formatting */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of all event artists */
  eventArtists?: Maybe<Array<EventArtist>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Time (with date) in UTC, use event's timezone for formatting */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<EventStateEnum>;
  ticketSales?: Maybe<EventSales>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type EventEventArtistsArgs = {
  artistId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EventArtist = {
  __typename?: 'EventArtist';
  artist: Artist;
  id: Scalars['Int']['output'];
  riders?: Maybe<Array<EventArtistRider>>;
};

export type EventArtistRider = {
  __typename?: 'EventArtistRider';
  /** Artist load in time */
  artistLoadInTime?: Maybe<Scalars['String']['output']>;
  /** Attachments for the rider */
  attachments?: Maybe<Array<Attachment>>;
  /** Number of backstage passes */
  backstagePassesNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  riderType: EventArtistRiderTypeEnum;
  /** Sound check type: "Full" or "Line" */
  soundCheckType?: Maybe<Scalars['String']['output']>;
  /** Number of performers on stage */
  stagePerformersNumber?: Maybe<Scalars['Int']['output']>;
  /** Stage sound check time */
  stageSoundCheckTime?: Maybe<Scalars['String']['output']>;
};

export type EventArtistRiderAttachmentInput = {
  /** Mark this attachment for destruction */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachment ID */
  id: Scalars['Int']['input'];
};

export type EventArtistRiderInput = {
  /** Artist load-in time */
  artistLoadInTime?: InputMaybe<Scalars['String']['input']>;
  /** Attachments for the rider */
  attachments?: InputMaybe<Array<EventArtistRiderAttachmentInput>>;
  /** Number of backstage passes */
  backstagePassesNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Rider ID, required for update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Rider notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Rider type */
  riderType?: InputMaybe<EventArtistRiderTypeEnum>;
  /** Sound check type */
  soundCheckType?: InputMaybe<Scalars['String']['input']>;
  /** Number of stage performers */
  stagePerformersNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Stage sound check time */
  stageSoundCheckTime?: InputMaybe<Scalars['String']['input']>;
};

export enum EventArtistRiderTypeEnum {
  Hospitality = 'HOSPITALITY',
  Tech = 'TECH'
}

/** EventCollection type */
export type EventCollection = {
  __typename?: 'EventCollection';
  /** A collection of paginated EventCollection */
  collection: Array<Event>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  events: Array<Event>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EventGroupArtist = {
  __typename?: 'EventGroupArtist';
  artist: Artist;
  artistId: Scalars['Int']['output'];
  eventGroupId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  /** Legacy event artist, used for compatibility with settlement sheets */
  legacyEventArtistId?: Maybe<Scalars['Int']['output']>;
  /** Legacy offer sheet ID */
  legacyOfferSheetId?: Maybe<Scalars['Int']['output']>;
  /** Legacy settlement sheet ID */
  legacySettlementSheetId?: Maybe<Scalars['Int']['output']>;
};

/** EventGroupArtistCollection type */
export type EventGroupArtistCollection = {
  __typename?: 'EventGroupArtistCollection';
  /** A collection of paginated EventGroupArtistCollection */
  collection: Array<EventGroupArtist>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type EventInput = {
  availableForDonation?: InputMaybe<Scalars['Boolean']['input']>;
  availableForProcessingFee?: InputMaybe<Scalars['Boolean']['input']>;
  availableForSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationEmailContent?: InputMaybe<Scalars['String']['input']>;
  doorTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  enableCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  footerContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mailPdfTickets?: InputMaybe<Scalars['Boolean']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  ticketLimit?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
  venueRoomId?: InputMaybe<Scalars['Int']['input']>;
};

export type EventOrders = {
  __typename?: 'EventOrders';
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerInfo?: Maybe<Customer>;
  eventId: Scalars['Int']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  ticketsInfo?: Maybe<Array<TicketInfo>>;
};

/** EventOrdersCollection type */
export type EventOrdersCollection = {
  __typename?: 'EventOrdersCollection';
  /** A collection of paginated EventOrdersCollection */
  collection: Array<EventOrders>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type EventSales = {
  __typename?: 'EventSales';
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  totalSalesLimit?: Maybe<Scalars['Float']['output']>;
  totalTickets?: Maybe<Scalars['Int']['output']>;
  totalTicketsAvailable?: Maybe<Scalars['Int']['output']>;
  totalTicketsOnHold?: Maybe<Scalars['Int']['output']>;
  totalTicketsSales?: Maybe<Scalars['Float']['output']>;
  totalTicketsSalesToday?: Maybe<Scalars['Float']['output']>;
  totalTicketsSold?: Maybe<Scalars['Int']['output']>;
  totalTicketsSoldToday?: Maybe<Scalars['Int']['output']>;
};

export type EventSalesAggregated = {
  __typename?: 'EventSalesAggregated';
  salesData: EventSales;
};

export type EventSearchArguments = {
  /** Search events ending at date */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Search by event name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Search events starting from date */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Search events by status */
  state?: InputMaybe<Array<EventStateEnum>>;
};

export enum EventStateEnum {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Deleted = 'DELETED',
  Hold = 'HOLD'
}

export type EventsApiArguments = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cymbalAccountKey?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Start date for searching events. Ignore id id is present. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum EventsFilterEnum {
  /** Show past events, most recent first */
  Past = 'PAST',
  /** Show upcoming events, soonest first */
  Upcoming = 'UPCOMING'
}

export type Expense = {
  __typename?: 'Expense';
  amount?: Maybe<Scalars['Float']['output']>;
  calculationType?: Maybe<VariableExpenseEnum>;
  calculationValue?: Maybe<Scalars['Float']['output']>;
  editable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ExpenseCategory = {
  __typename?: 'ExpenseCategory';
  editable: Scalars['Boolean']['output'];
  expenses: Array<Expense>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  totalExpenses: Scalars['Float']['output'];
};

export enum FeeStructureEnum {
  AtCost = 'at_cost',
  Default = 'default',
  Discount = 'discount',
  Standard = 'standard',
  Waived = 'waived'
}

export type FilterParams = {
  __typename?: 'FilterParams';
  accountIds: Array<Scalars['Int']['output']>;
};

/** Autogenerated input type of GeneratePdf */
export type GeneratePdfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If set to true, PDF will be regenerated even if it already exists */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  settlementId: Scalars['Int']['input'];
};

/** Autogenerated return type of GeneratePdf. */
export type GeneratePdfPayload = {
  __typename?: 'GeneratePdfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  settlement: Settlement;
};

/** Autogenerated input type of GeneratePerformanceDates */
export type GeneratePerformanceDatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of GeneratePerformanceDates. */
export type GeneratePerformanceDatesPayload = {
  __typename?: 'GeneratePerformanceDatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

export type Inquiry = {
  __typename?: 'Inquiry';
  contact: Contact;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  eventArtist: EventGroupArtist;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ItemBreakdown = {
  __typename?: 'ItemBreakdown';
  basePrice: Scalars['Float']['output'];
  convenienceFee?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type List = {
  __typename?: 'List';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  gross: Scalars['Float']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  listType: ListTypeEnum;
  name: Scalars['String']['output'];
  projected: Scalars['Int']['output'];
};

export enum ListTypeEnum {
  /** Guest list */
  GuestList = 'guest_list',
  /** Paid list */
  PaidList = 'paid_list'
}

/** Autogenerated input type of LockSheet */
export type LockSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of LockSheet. */
export type LockSheetPayload = {
  __typename?: 'LockSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

export type ManualTicketSale = {
  __typename?: 'ManualTicketSale';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ManualTicketSaleAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  ticketsSold: Scalars['Int']['input'];
};

export type Me = {
  __typename?: 'Me';
  accounts?: Maybe<Array<Account>>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  app?: Maybe<AppMutation>;
  checkout?: Maybe<CheckoutMutation>;
  createAnnounceDetail?: Maybe<CreateAnnounceDetailPayload>;
  createAttachment?: Maybe<CreateAttachmentPayload>;
  createCalendar?: Maybe<CreateCalendarPayload>;
  createCompany?: Maybe<CreateCompanyPayload>;
  createInquiry?: Maybe<CreateInquiryPayload>;
  deleteContact?: Maybe<DeleteContactPayload>;
  generateSettlementPdf?: Maybe<GeneratePdfPayload>;
  offerSheet?: Maybe<OfferSheetMutation>;
  organizationSignupMutation?: Maybe<OrganizationSignupMutationPayload>;
  removeCalendar?: Maybe<RemoveCalendarPayload>;
  requestAuthTokenMutation?: Maybe<RequestAuthTokenMutationPayload>;
  resetCalendarToken?: Maybe<ResetCalendarTokenPayload>;
  saveContact?: Maybe<SaveContactPayload>;
  signinUserMutation?: Maybe<SigninUserMutationPayload>;
  sortEventTickets?: Maybe<SortTicketsPayload>;
  ticketBuyer?: Maybe<TicketbuyerMutation>;
  tokenAuthMutation?: Maybe<TokenAuthMutationPayload>;
  updateCalendar?: Maybe<UpdateCalendarPayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  updateEventArtistSettlement?: Maybe<UpdateEventArtistSettlementPayload>;
  updateInquiry?: Maybe<UpdateInquiryPayload>;
};


export type MutationCreateAnnounceDetailArgs = {
  input: CreateAnnounceDetailInput;
};


export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type MutationCreateCalendarArgs = {
  input: CreateCalendarInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateInquiryArgs = {
  input: CreateInquiryInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationGenerateSettlementPdfArgs = {
  input: GeneratePdfInput;
};


export type MutationOrganizationSignupMutationArgs = {
  input: OrganizationSignupMutationInput;
};


export type MutationRemoveCalendarArgs = {
  input: RemoveCalendarInput;
};


export type MutationRequestAuthTokenMutationArgs = {
  input: RequestAuthTokenMutationInput;
};


export type MutationResetCalendarTokenArgs = {
  input: ResetCalendarTokenInput;
};


export type MutationSaveContactArgs = {
  input: SaveContactInput;
};


export type MutationSigninUserMutationArgs = {
  input: SigninUserMutationInput;
};


export type MutationSortEventTicketsArgs = {
  input: SortTicketsInput;
};


export type MutationTokenAuthMutationArgs = {
  input: TokenAuthMutationInput;
};


export type MutationUpdateCalendarArgs = {
  input: UpdateCalendarInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateEventArtistSettlementArgs = {
  input: UpdateEventArtistSettlementInput;
};


export type MutationUpdateInquiryArgs = {
  input: UpdateInquiryInput;
};

export type MutationFilterParams = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OfferSheetContact = {
  __typename?: 'OfferSheetContact';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type OfferSheetMutation = {
  __typename?: 'OfferSheetMutation';
  applyTemplate?: Maybe<ApplyTemplatePayload>;
  createTemplate?: Maybe<CreateTemplatePayload>;
  createVersion?: Maybe<CreateSheetVersionPayload>;
  deleteExpense?: Maybe<DeleteExpensePayload>;
  deleteExpenseCategory?: Maybe<DeleteExpenseCategoryPayload>;
  deleteList?: Maybe<DeleteListPayload>;
  deleteOfferContact?: Maybe<DeleteOfferContactPayload>;
  deleteTicket?: Maybe<DeleteTicketPayload>;
  generatePerformanceDates?: Maybe<GeneratePerformanceDatesPayload>;
  lockSheet?: Maybe<LockSheetPayload>;
  updateSheet?: Maybe<UpdateSheetPayload>;
  upsertAgent?: Maybe<UpsertAgentPayload>;
  upsertExpense?: Maybe<UpsertExpensePayload>;
  upsertExpenseCategory?: Maybe<UpsertExpenseCategoryPayload>;
  upsertList?: Maybe<UpsertListPayload>;
  upsertOfferContact?: Maybe<UpsertOfferContactPayload>;
  upsertTicket?: Maybe<UpsertTicketPayload>;
};


export type OfferSheetMutationApplyTemplateArgs = {
  input: ApplyTemplateInput;
};


export type OfferSheetMutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type OfferSheetMutationCreateVersionArgs = {
  input: CreateSheetVersionInput;
};


export type OfferSheetMutationDeleteExpenseArgs = {
  input: DeleteExpenseInput;
};


export type OfferSheetMutationDeleteExpenseCategoryArgs = {
  input: DeleteExpenseCategoryInput;
};


export type OfferSheetMutationDeleteListArgs = {
  input: DeleteListInput;
};


export type OfferSheetMutationDeleteOfferContactArgs = {
  input: DeleteOfferContactInput;
};


export type OfferSheetMutationDeleteTicketArgs = {
  input: DeleteTicketInput;
};


export type OfferSheetMutationGeneratePerformanceDatesArgs = {
  input: GeneratePerformanceDatesInput;
};


export type OfferSheetMutationLockSheetArgs = {
  input: LockSheetInput;
};


export type OfferSheetMutationUpdateSheetArgs = {
  input: UpdateSheetInput;
};


export type OfferSheetMutationUpsertAgentArgs = {
  input: UpsertAgentInput;
};


export type OfferSheetMutationUpsertExpenseArgs = {
  input: UpsertExpenseInput;
};


export type OfferSheetMutationUpsertExpenseCategoryArgs = {
  input: UpsertExpenseCategoryInput;
};


export type OfferSheetMutationUpsertListArgs = {
  input: UpsertListInput;
};


export type OfferSheetMutationUpsertOfferContactArgs = {
  input: UpsertOfferContactInput;
};


export type OfferSheetMutationUpsertTicketArgs = {
  input: UpsertTicketInput;
};

export type OfferTicket = {
  __typename?: 'OfferTicket';
  gross: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  projected: Scalars['Int']['output'];
  section?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  /** Order code */
  code?: Maybe<Scalars['String']['output']>;
  /** Customer for the order */
  customer?: Maybe<Customer>;
  /** Related Event */
  event?: Maybe<Event>;
  /** Order ID */
  id: Scalars['Int']['output'];
  /** Ticket layout */
  ticketLayout?: Maybe<Scalars['String']['output']>;
  /** List of tickets in the order */
  tickets?: Maybe<Array<Ticket>>;
  /** Venue for the event */
  venue?: Maybe<Venue>;
};

export type OrderSummary = {
  __typename?: 'OrderSummary';
  /** Billing address */
  address?: Maybe<PublicAddress>;
  breakdown?: Maybe<PriceBreakdown>;
  companyName?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CheckoutCustomer>;
  event: CheckoutEvent;
  fingerprint: Scalars['String']['output'];
  items: Array<OrderTicket>;
  state: Scalars['String']['output'];
  vatId?: Maybe<Scalars['String']['output']>;
};

export type OrderTicket = {
  __typename?: 'OrderTicket';
  breakdown?: Maybe<ItemBreakdown>;
  discountCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  seat?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
};

export type OrdersApiArguments = {
  cymbalAccountKey: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of OrganizationSignupMutation */
export type OrganizationSignupMutationInput = {
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
};

/** Autogenerated return type of OrganizationSignupMutation. */
export type OrganizationSignupMutationPayload = {
  __typename?: 'OrganizationSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<SettlementAttachment>>;
  checkWireNr?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateDue?: Maybe<Scalars['ISO8601Date']['output']>;
  datePaid?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  payee?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<PaymentTypeEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type PaymentAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkWireNr?: InputMaybe<Scalars['String']['input']>;
  dateDue?: InputMaybe<Scalars['ISO8601Date']['input']>;
  datePaid?: InputMaybe<Scalars['ISO8601Date']['input']>;
  deletions?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payee?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentTypeEnum>;
};

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  eventId: Scalars['Int']['output'];
  paymentIntent?: Maybe<PaymentIntent>;
  paymentProcessor: Scalars['String']['output'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stripeAccount: Scalars['String']['output'];
};

export enum PaymentTypeEnum {
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  None = 'NONE',
  WireTransfer = 'WIRE_TRANSFER'
}

export type Permission = {
  __typename?: 'Permission';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  options: Array<PermissionOption>;
};

export type PermissionAttributesInput = {
  add_artist?: InputMaybe<Scalars['Boolean']['input']>;
  add_hold?: InputMaybe<Scalars['Boolean']['input']>;
  artists__financials?: InputMaybe<Scalars['String']['input']>;
  artists__hospitality_rider?: InputMaybe<Scalars['String']['input']>;
  artists__stats_sheet?: InputMaybe<Scalars['String']['input']>;
  artists__tech_rider?: InputMaybe<Scalars['String']['input']>;
  box_office_app?: InputMaybe<Scalars['Boolean']['input']>;
  budget__actual_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__actual_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__actual_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__projected_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__projected_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__projected_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__shared_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__summary?: InputMaybe<Scalars['String']['input']>;
  budget__template?: InputMaybe<Scalars['String']['input']>;
  cancel_event?: InputMaybe<Scalars['Boolean']['input']>;
  closeout_sheet__access?: InputMaybe<Scalars['String']['input']>;
  closeout_sheet__manual_tickets?: InputMaybe<Scalars['String']['input']>;
  confirm_date?: InputMaybe<Scalars['Boolean']['input']>;
  download_will_call?: InputMaybe<Scalars['Boolean']['input']>;
  event_details__announce?: InputMaybe<Scalars['String']['input']>;
  event_details__audit_log?: InputMaybe<Scalars['String']['input']>;
  event_details__canceled_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__confirmed_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__deleted_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__hold_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__name?: InputMaybe<Scalars['String']['input']>;
  event_details__notes?: InputMaybe<Scalars['String']['input']>;
  other__artists?: InputMaybe<Scalars['String']['input']>;
  other__event_notes?: InputMaybe<Scalars['String']['input']>;
  other__orders?: InputMaybe<Scalars['String']['input']>;
  other__projections?: InputMaybe<Scalars['String']['input']>;
  reports__by_day?: InputMaybe<Scalars['String']['input']>;
  reports__by_email_opt_ins?: InputMaybe<Scalars['String']['input']>;
  reports__by_event_cancelation?: InputMaybe<Scalars['String']['input']>;
  reports__by_payment?: InputMaybe<Scalars['String']['input']>;
  sales_info__fees?: InputMaybe<Scalars['String']['input']>;
  sales_info__gbor?: InputMaybe<Scalars['String']['input']>;
  sales_info__number_sold?: InputMaybe<Scalars['String']['input']>;
  settings__integrations?: InputMaybe<Scalars['String']['input']>;
  settings__privileges?: InputMaybe<Scalars['String']['input']>;
  settings__team?: InputMaybe<Scalars['String']['input']>;
  settings__venues?: InputMaybe<Scalars['String']['input']>;
  ticketing__guest_list?: InputMaybe<Scalars['String']['input']>;
  ticketing__tickets?: InputMaybe<Scalars['String']['input']>;
  ticketing__will_call?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export type PermissionOption = {
  __typename?: 'PermissionOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  itemsBreakdown?: Maybe<Array<BreakdownItem>>;
  itemsTotal?: Maybe<Scalars['Float']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  totalBreakdown?: Maybe<Array<BreakdownItem>>;
};

export type ProtectedEvent = {
  __typename?: 'ProtectedEvent';
  artists?: Maybe<Array<Artist>>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['Time']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceMax?: Maybe<Scalars['Float']['output']>;
  priceMin?: Maybe<Scalars['Float']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  salesQty: Scalars['Int']['output'];
  salesRevenue: Scalars['Float']['output'];
  scheduling?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PublicVenue>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** ProtectedEventCollection type */
export type ProtectedEventCollection = {
  __typename?: 'ProtectedEventCollection';
  /** A collection of paginated ProtectedEventCollection */
  collection: Array<ProtectedEvent>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type PublicAccount = {
  __typename?: 'PublicAccount';
  address?: Maybe<Address>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicAddress = {
  __typename?: 'PublicAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type PublicAnnounceArtist = {
  __typename?: 'PublicAnnounceArtist';
  /** @deprecated Use `links` field instead */
  applemusic?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  bandcamp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  facebook?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  instagram?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  lastfm?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<PublicArtistLink>>;
  name: Scalars['String']['output'];
  /** @deprecated Use `links` field instead */
  songkick?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  spotify?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  twitter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  website?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  wikipedia?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  youtube?: Maybe<Scalars['String']['output']>;
};

export type PublicArtistLink = {
  __typename?: 'PublicArtistLink';
  url: Scalars['String']['output'];
};

export type PublicEvent = {
  __typename?: 'PublicEvent';
  announceArtists?: Maybe<Array<PublicAnnounceArtist>>;
  announceImages: Array<AnnounceImage>;
  /** @deprecated Use `announce_artists` instead */
  artists?: Maybe<Array<Artist>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use venue.currency instead */
  currency?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `start_time_utc` */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `door_time_utc` */
  doorTime?: Maybe<Scalars['Time']['output']>;
  doorTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use `end_time_utc` */
  endTime?: Maybe<Scalars['Time']['output']>;
  endTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `announce_images` instead */
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated Use `announce_images` instead */
  images: Array<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openIn?: Maybe<Scalars['String']['output']>;
  priceMax?: Maybe<Scalars['Float']['output']>;
  priceMin?: Maybe<Scalars['Float']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  scheduling?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `start_time_utc` */
  startTime?: Maybe<Scalars['Time']['output']>;
  startTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use button_text */
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tickets?: Maybe<Array<PublicTicket>>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PublicVenue>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** PublicEventCollection type */
export type PublicEventCollection = {
  __typename?: 'PublicEventCollection';
  /** A collection of paginated PublicEventCollection */
  collection: Array<PublicEvent>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type PublicTicket = {
  __typename?: 'PublicTicket';
  fee?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
  sectionQuantity?: Maybe<Scalars['Int']['output']>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicVenue = {
  __typename?: 'PublicVenue';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `postal_code` instead */
  postal?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `timezone` instead */
  timeZone?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  app?: Maybe<App>;
  barDeals: Array<Deal>;
  checkout: Checkout;
  /** @deprecated Use `config` field in `CheckoutEventType` */
  checkoutConfig: Array<CheckoutConfig>;
  contact: Contact;
  contacts?: Maybe<Array<Contact>>;
  event?: Maybe<Event>;
  /** Find artist settlement by ID */
  eventArtistSettlement?: Maybe<Settlement>;
  eventToken: Scalars['String']['output'];
  me?: Maybe<Me>;
  /** Find offer sheet by ID */
  offerSheet?: Maybe<Sheet>;
  offerSheetContacts: Array<OfferSheetContact>;
  /** Returns paginated list of found orders, according to parameters */
  paginatedEventOrders?: Maybe<EventOrdersCollection>;
  /** Returns paginated list of found events, according to parameters */
  paginatedEvents?: Maybe<PublicEventCollection>;
  /** Returns paginated list of found events, according to parameters */
  protectedEvents?: Maybe<ProtectedEventCollection>;
  /** Returns list of found events, according to parameters */
  publicEvents?: Maybe<Array<PublicEvent>>;
  templates?: Maybe<Array<Template>>;
  ticketDeals: Array<Deal>;
  ticketbuyer?: Maybe<Ticketbuyer>;
  vpConfig?: Maybe<Config>;
};


export type QueryAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckoutConfigArgs = {
  eventIds: Array<Scalars['ID']['input']>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventArtistSettlementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventTokenArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOfferSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOfferSheetContactsArgs = {
  offerSheetId: Scalars['Int']['input'];
};


export type QueryPaginatedEventOrdersArgs = {
  arguments: OrdersApiArguments;
};


export type QueryPaginatedEventsArgs = {
  arguments: EventsApiArguments;
};


export type QueryProtectedEventsArgs = {
  arguments: EventsApiArguments;
};


export type QueryPublicEventsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum RefundActionEnum {
  Credit = 'CREDIT',
  Donate = 'DONATE',
  Refund = 'REFUND'
}

export enum RefundStatusEnum {
  Credited = 'CREDITED',
  Donated = 'DONATED',
  None = 'NONE',
  Refunded = 'REFUNDED',
  RefundChoose = 'REFUND_CHOOSE'
}

/** Autogenerated input type of ReleaseLock */
export type ReleaseLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of ReleaseLock. */
export type ReleaseLockPayload = {
  __typename?: 'ReleaseLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shoppingCart?: Maybe<ShoppingCart>;
};

/** Autogenerated input type of RemoveCalendar */
export type RemoveCalendarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveCalendar. */
export type RemoveCalendarPayload = {
  __typename?: 'RemoveCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of RemoveEventArtistMutation */
export type RemoveEventArtistMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventArtistId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveEventArtistMutation. */
export type RemoveEventArtistMutationPayload = {
  __typename?: 'RemoveEventArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveEventGroupArtistMutation */
export type RemoveEventGroupArtistMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventGroupArtistId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveEventGroupArtistMutation. */
export type RemoveEventGroupArtistMutationPayload = {
  __typename?: 'RemoveEventGroupArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReorderEventArtistsMutation */
export type ReorderEventArtistsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventArtistIds: Array<Scalars['Int']['input']>;
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReorderEventArtistsMutation. */
export type ReorderEventArtistsMutationPayload = {
  __typename?: 'ReorderEventArtistsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  eventArtists?: Maybe<Array<EventArtist>>;
  success: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  name: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

/** Autogenerated input type of RequestAuthTokenMutation */
export type RequestAuthTokenMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of RequestAuthTokenMutation. */
export type RequestAuthTokenMutationPayload = {
  __typename?: 'RequestAuthTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type RescheduleInfo = {
  __typename?: 'RescheduleInfo';
  date: Scalars['ISO8601Date']['output'];
  /** Date is irrelevant, only time part is used */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date is irrelevant, only time part is used */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date is irrelevant, only time part is used */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of ResendTicketConfirmation */
export type ResendTicketConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};

/** Autogenerated return type of ResendTicketConfirmation. */
export type ResendTicketConfirmationPayload = {
  __typename?: 'ResendTicketConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResetCalendarToken */
export type ResetCalendarTokenInput = {
  calendarId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResetCalendarToken. */
export type ResetCalendarTokenPayload = {
  __typename?: 'ResetCalendarTokenPayload';
  calendar?: Maybe<Calendar>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of ResetPasswordMutation */
export type ResetPasswordMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPasswordMutation. */
export type ResetPasswordMutationPayload = {
  __typename?: 'ResetPasswordMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of SaveAccountMutation */
export type SaveAccountMutationInput = {
  accountAttributes: AccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveAccountMutation. */
export type SaveAccountMutationPayload = {
  __typename?: 'SaveAccountMutationPayload';
  account?: Maybe<AccountDetails>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of SaveAppConfigMutation */
export type SaveAppConfigMutationInput = {
  appConfig: AppConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveAppConfigMutation. */
export type SaveAppConfigMutationPayload = {
  __typename?: 'SaveAppConfigMutationPayload';
  appConfig?: Maybe<AppConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of SaveArtistMutation */
export type SaveArtistMutationInput = {
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveArtistMutation. */
export type SaveArtistMutationPayload = {
  __typename?: 'SaveArtistMutationPayload';
  artist?: Maybe<Artist>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveContact */
export type SaveContactInput = {
  agencyName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveContact. */
export type SaveContactPayload = {
  __typename?: 'SaveContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of SaveEventArtistRiderMutation */
export type SaveEventArtistRiderMutationInput = {
  /** Artist ID */
  artistId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Event ID */
  eventId: Scalars['Int']['input'];
  /** Rider details */
  rider: EventArtistRiderInput;
};

/** Autogenerated return type of SaveEventArtistRiderMutation. */
export type SaveEventArtistRiderMutationPayload = {
  __typename?: 'SaveEventArtistRiderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  rider?: Maybe<EventArtistRider>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEventMutation */
export type SaveEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: EventInput;
};

/** Autogenerated return type of SaveEventMutation. */
export type SaveEventMutationPayload = {
  __typename?: 'SaveEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveOrder */
export type SaveOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerInformation: CustomerInformationInput;
  eventId: Scalars['Int']['input'];
  orderFingerprint?: InputMaybe<Scalars['Int']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of SaveOrder. */
export type SaveOrderPayload = {
  __typename?: 'SaveOrderPayload';
  changeToken?: Maybe<ChangeCustomerToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveTeamRoleMutation */
export type SaveTeamRoleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamRole: TeamRoleInput;
};

/** Autogenerated return type of SaveTeamRoleMutation. */
export type SaveTeamRoleMutationPayload = {
  __typename?: 'SaveTeamRoleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  teamRoleDetails?: Maybe<TeamRoleDetails>;
};

/** Autogenerated input type of SaveTicketLayoutMutation */
export type SaveTicketLayoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ticketLayout: TicketLayoutAttributes;
};

/** Autogenerated return type of SaveTicketLayoutMutation. */
export type SaveTicketLayoutMutationPayload = {
  __typename?: 'SaveTicketLayoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  ticketLayout?: Maybe<TicketLayout>;
};

/** Autogenerated input type of SaveUserAccountMutation */
export type SaveUserAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccount: UserAccountAttributes;
};

/** Autogenerated return type of SaveUserAccountMutation. */
export type SaveUserAccountMutationPayload = {
  __typename?: 'SaveUserAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  userAccount?: Maybe<UserAccount>;
};

/** Autogenerated input type of SaveUserMutation */
export type SaveUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  user: UserAttributes;
};

/** Autogenerated return type of SaveUserMutation. */
export type SaveUserMutationPayload = {
  __typename?: 'SaveUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SaveVenueMutation */
export type SaveVenueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venue: VenueAttributes;
};

/** Autogenerated return type of SaveVenueMutation. */
export type SaveVenueMutationPayload = {
  __typename?: 'SaveVenueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of SaveWhitelabelConfigMutation */
export type SaveWhitelabelConfigMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: WhitelabelAttributes;
};

/** Autogenerated return type of SaveWhitelabelConfigMutation. */
export type SaveWhitelabelConfigMutationPayload = {
  __typename?: 'SaveWhitelabelConfigMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  config?: Maybe<WhitelabelConfig>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of SaveWidgetConfigMutation */
export type SaveWidgetConfigMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  widget: WidgetAttributes;
};

/** Autogenerated return type of SaveWidgetConfigMutation. */
export type SaveWidgetConfigMutationPayload = {
  __typename?: 'SaveWidgetConfigMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  widget?: Maybe<WidgetConfig>;
};

export type SearchResultArtist = {
  __typename?: 'SearchResultArtist';
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  soundchartsUuid?: Maybe<Scalars['String']['output']>;
};

export type SeatsioConfig = {
  __typename?: 'SeatsioConfig';
  eventKey: Scalars['String']['output'];
  objectWithoutPricingSelectable?: Maybe<Scalars['Boolean']['output']>;
  publishedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  workspaceKey: Scalars['String']['output'];
};

/** Autogenerated input type of SendUserAccountInvitationMutation */
export type SendUserAccountInvitationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccountId: Scalars['Int']['input'];
};

/** Autogenerated return type of SendUserAccountInvitationMutation. */
export type SendUserAccountInvitationMutationPayload = {
  __typename?: 'SendUserAccountInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

export type Settlement = {
  __typename?: 'Settlement';
  address?: Maybe<Address>;
  availableEvents?: Maybe<Array<Event>>;
  barDeals?: Maybe<Array<SettlementDeal>>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customExpenses?: Maybe<Array<CustomExpense>>;
  deals?: Maybe<Array<SettlementDeal>>;
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  events?: Maybe<Array<Event>>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  manualTicketSales?: Maybe<Array<ManualTicketSale>>;
  payments?: Maybe<Array<Payment>>;
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<SettlementTypeEnum>;
  signedContracts?: Maybe<Array<SettlementContract>>;
  taxAttachments?: Maybe<Array<SettlementAttachment>>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxWithholdingAmount?: Maybe<Scalars['Float']['output']>;
  taxWithholdingType?: Maybe<SettlementTaxWithholdingTypeEnum>;
  ticketDeals?: Maybe<Array<SettlementDeal>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SettlementAttachment = {
  __typename?: 'SettlementAttachment';
  identifier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SettlementContract = {
  __typename?: 'SettlementContract';
  identifier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SettlementDeal = {
  __typename?: 'SettlementDeal';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<SettlementAttachment>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deal?: Maybe<Deal>;
  /** DEPRECATED */
  dealId?: Maybe<Scalars['Int']['output']>;
  dealType?: Maybe<DealEnum>;
  expenseAmount?: Maybe<Scalars['Float']['output']>;
  firstAmount?: Maybe<Scalars['Float']['output']>;
  hitAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  percent?: Maybe<Scalars['Float']['output']>;
  showTicketSales?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum SettlementTaxWithholdingTypeEnum {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum SettlementTypeEnum {
  /** Settlement based on manual ticket sales entry */
  ManualGbor = 'MANUAL_GBOR',
  /** Settlement based on tickets sales at selected events in corresponding event group */
  TicketSalesEvents = 'TICKET_SALES_EVENTS'
}

export type Sheet = {
  __typename?: 'Sheet';
  agent?: Maybe<Agent>;
  artistName?: Maybe<Scalars['String']['output']>;
  attendeeCount?: Maybe<Scalars['Int']['output']>;
  billing?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<OfferSheetContact>>;
  dealArtistGuarantee?: Maybe<Scalars['Float']['output']>;
  dealGborPercentage?: Maybe<Scalars['Float']['output']>;
  dealType?: Maybe<DealEnum>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventGroupId?: Maybe<Scalars['Int']['output']>;
  exclusivity?: Maybe<Scalars['String']['output']>;
  expenseCategories?: Maybe<Array<ExpenseCategory>>;
  headlinerGuarantee?: Maybe<Scalars['Float']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  listCount?: Maybe<Scalars['Int']['output']>;
  lists?: Maybe<Array<List>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lockedBy?: Maybe<User>;
  merch?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offerDate: Scalars['ISO8601Date']['output'];
  offerExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  performanceDatesDescription?: Maybe<Scalars['String']['output']>;
  promoterName?: Maybe<Scalars['String']['output']>;
  promoterProfitPercentage?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  summary?: Maybe<Summary>;
  support?: Maybe<Scalars['String']['output']>;
  supportGuarantee?: Maybe<Scalars['Float']['output']>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  tickets?: Maybe<Array<OfferTicket>>;
  venueAddress?: Maybe<Scalars['String']['output']>;
  venueLogo?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
  venueTimezone?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<SheetVersion>>;
};

export type SheetVersion = {
  __typename?: 'SheetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionName?: Maybe<Scalars['String']['output']>;
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  controlQuantity: Scalars['Int']['output'];
  items?: Maybe<Array<ShoppingCartItem>>;
  lockExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notABotUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  priceBreakdown: PriceBreakdown;
  token: Scalars['String']['output'];
  /** Total amount in cents */
  total: Scalars['Int']['output'];
};

export type ShoppingCartInput = {
  eventId: Scalars['Int']['input'];
  items?: InputMaybe<Array<ShoppingCartItemInput>>;
};

export type ShoppingCartItem = {
  __typename?: 'ShoppingCartItem';
  amount?: Maybe<Scalars['Float']['output']>;
  breakdown?: Maybe<ItemBreakdown>;
  count?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  itemType: ShoppingCartItemTypeEnum;
  name?: Maybe<Scalars['String']['output']>;
  typeHash: Scalars['String']['output'];
};

export type ShoppingCartItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
  itemType: ShoppingCartItemTypeEnum;
};

export enum ShoppingCartItemTypeEnum {
  Discount = 'DISCOUNT',
  Donation = 'DONATION',
  Presale = 'PRESALE',
  SeatTicket = 'SEAT_TICKET',
  Ticket = 'TICKET'
}

/** Autogenerated input type of SigninUserMutation */
export type SigninUserMutationInput = {
  /** AccessToken, obtained from cognito. This is used when the user identified by cognito UUID already exists in the db. */
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDToken, obtained from cognito. Used when the user can't be identified by cognito UUID  */
  idToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SigninUserMutation. */
export type SigninUserMutationPayload = {
  __typename?: 'SigninUserMutationPayload';
  /** Authentication token */
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** URL to redirect to after sign in */
  returnTo?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SortTickets */
export type SortTicketsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  ticketBlueprintIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of SortTickets. */
export type SortTicketsPayload = {
  __typename?: 'SortTicketsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Summary = {
  __typename?: 'Summary';
  artistBackend?: Maybe<Scalars['Float']['output']>;
  artistPotential?: Maybe<Scalars['Float']['output']>;
  breakeven?: Maybe<Scalars['Float']['output']>;
  fixedExpenses?: Maybe<Scalars['Float']['output']>;
  gbor?: Maybe<Scalars['Float']['output']>;
  netPotential?: Maybe<Scalars['Float']['output']>;
  overage?: Maybe<Scalars['Float']['output']>;
  promoterPotential?: Maybe<Scalars['Float']['output']>;
  promoterProfit?: Maybe<Scalars['Float']['output']>;
  splitPoint?: Maybe<Scalars['Float']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  totalExpenses?: Maybe<Scalars['Float']['output']>;
  variableExpenses?: Maybe<Scalars['Float']['output']>;
};

export type TeamRole = {
  __typename?: 'TeamRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TeamRoleDetails = {
  __typename?: 'TeamRoleDetails';
  allowances: Array<Allowance>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissionGroups: Array<PermissionGroup>;
};

export type TeamRoleInput = {
  accountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  permissionAttributes: PermissionAttributesInput;
};

export type Template = {
  __typename?: 'Template';
  id: Scalars['Int']['output'];
  templateName: Scalars['String']['output'];
};

export type Ticket = {
  __typename?: 'Ticket';
  /** User who checked in the ticket */
  checkedInBy?: Maybe<PublicUser>;
  /** First name of the ticket holder */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Ticket ID */
  id: Scalars['Int']['output'];
  /** Last name of the ticket holder */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Ticket blueprint name */
  name?: Maybe<Scalars['String']['output']>;
  /** PDF preview URL */
  pdfPreviewUrl?: Maybe<Scalars['String']['output']>;
  /** PDF URL */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Ticket price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Seat number for the ticket */
  seat?: Maybe<Scalars['String']['output']>;
  /** Table number for the ticket */
  table?: Maybe<Scalars['String']['output']>;
  /** Ticket type */
  ticketType: Scalars['String']['output'];
  /** Unique token for the ticket */
  token?: Maybe<Scalars['String']['output']>;
};

export type TicketInfo = {
  __typename?: 'TicketInfo';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalFee: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
};

export type TicketLayout = {
  __typename?: 'TicketLayout';
  /** Whether the ticket layout should be default */
  default: Scalars['Boolean']['output'];
  fglString?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  layout?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
};

export type TicketLayoutAttributes = {
  /** Whether the ticket layout should be default */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  fglString?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  layout?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for TicketLayout. */
export type TicketLayoutConnection = {
  __typename?: 'TicketLayoutConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TicketLayoutEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TicketLayout>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TicketLayoutEdge = {
  __typename?: 'TicketLayoutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TicketLayout>;
};

export type Ticketbuyer = {
  __typename?: 'Ticketbuyer';
  myCredits?: Maybe<Array<TicketbuyerCreditCache>>;
  myEvents?: Maybe<Array<TicketbuyerEvent>>;
};


export type TicketbuyerMyEventsArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EventsFilterEnum>;
};

export type TicketbuyerCreditCache = {
  __typename?: 'TicketbuyerCreditCache';
  account?: Maybe<PublicAccount>;
  balance?: Maybe<Scalars['Float']['output']>;
};

export type TicketbuyerEvent = {
  __typename?: 'TicketbuyerEvent';
  announceDetail?: Maybe<AnnounceDetail>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  date: Scalars['ISO8601Date']['output'];
  /** Time (with date) in UTC, use event's timezone for formatting */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of all event artists */
  eventArtists?: Maybe<Array<EventArtist>>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orders?: Maybe<Array<TicketbuyerOrder>>;
  rescheduledFrom?: Maybe<RescheduleInfo>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<EventStateEnum>;
  status?: Maybe<Scalars['String']['output']>;
  ticketSales?: Maybe<EventSales>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
};


export type TicketbuyerEventEventArtistsArgs = {
  artistId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketbuyerMutation = {
  __typename?: 'TicketbuyerMutation';
  chooseRefundOptionMutation?: Maybe<ChooseRefundOptionMutationPayload>;
  resendTicketConfirmation?: Maybe<ResendTicketConfirmationPayload>;
};


export type TicketbuyerMutationChooseRefundOptionMutationArgs = {
  input: ChooseRefundOptionMutationInput;
};


export type TicketbuyerMutationResendTicketConfirmationArgs = {
  input: ResendTicketConfirmationInput;
};

export type TicketbuyerOrder = {
  __typename?: 'TicketbuyerOrder';
  ccType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  platformFee?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  refundStatus?: Maybe<RefundStatusEnum>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  tickets?: Maybe<Array<TicketbuyerTicket>>;
};

export type TicketbuyerTicket = {
  __typename?: 'TicketbuyerTicket';
  fee?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  seat?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TokenAuthMutation */
export type TokenAuthMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loginToken: Scalars['String']['input'];
};

/** Autogenerated return type of TokenAuthMutation. */
export type TokenAuthMutationPayload = {
  __typename?: 'TokenAuthMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type TrackingAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  provider: TrackingProviderEnum;
  trackingId: Scalars['String']['input'];
};

export type TrackingEntry = {
  __typename?: 'TrackingEntry';
  conversionLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  provider: TrackingProviderEnum;
  trackingId: Scalars['String']['output'];
};

export enum TrackingProviderEnum {
  /** Facebook pixel */
  Facebook = 'facebook',
  /** Google Analytics */
  Ga = 'ga'
}

/** Autogenerated input type of UpdateCalendar */
export type UpdateCalendarInput = {
  calendar: CalendarInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCalendar. */
export type UpdateCalendarPayload = {
  __typename?: 'UpdateCalendarPayload';
  calendar?: Maybe<Calendar>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  facebookUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateCompany. */
export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UpdateEventArtistSettlement */
export type UpdateEventArtistSettlementInput = {
  address?: InputMaybe<AddressAttributes>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customExpenses?: InputMaybe<Array<CustomExpenseAttributes>>;
  deals?: InputMaybe<Array<DealAttributes>>;
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['ID']['input'];
  manualTicketSales?: InputMaybe<Array<ManualTicketSaleAttributes>>;
  payments?: InputMaybe<Array<PaymentAttributes>>;
  settlementType?: InputMaybe<SettlementTypeEnum>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxWithholding?: InputMaybe<Scalars['Boolean']['input']>;
  taxWithholdingAmount?: InputMaybe<Scalars['Float']['input']>;
  taxWithholdingType?: InputMaybe<SettlementTaxWithholdingTypeEnum>;
};

/** Autogenerated return type of UpdateEventArtistSettlement. */
export type UpdateEventArtistSettlementPayload = {
  __typename?: 'UpdateEventArtistSettlementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  settlement?: Maybe<Settlement>;
};

/** Autogenerated input type of UpdateInquiry */
export type UpdateInquiryInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eventArtistId?: InputMaybe<Scalars['ID']['input']>;
  inquiryId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateInquiry. */
export type UpdateInquiryPayload = {
  __typename?: 'UpdateInquiryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  inquiry?: Maybe<Inquiry>;
};

/** Autogenerated input type of UpdateOrderEmailMutation */
export type UpdateOrderEmailMutationInput = {
  changeToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fingerprint: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOrderEmailMutation. */
export type UpdateOrderEmailMutationPayload = {
  __typename?: 'UpdateOrderEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orderSummary?: Maybe<OrderSummary>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdatePaymentInformation */
export type UpdatePaymentInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePaymentInformation. */
export type UpdatePaymentInformationPayload = {
  __typename?: 'UpdatePaymentInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  paymentInformation?: Maybe<Array<PaymentInformation>>;
};

/** Autogenerated input type of UpdateSheet */
export type UpdateSheetInput = {
  agencyName?: InputMaybe<Scalars['String']['input']>;
  agent?: InputMaybe<Scalars['String']['input']>;
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  billing?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dealArtistGuarantee?: InputMaybe<Scalars['Float']['input']>;
  dealGborPercentage?: InputMaybe<Scalars['Float']['input']>;
  dealType?: InputMaybe<DealEnum>;
  doorTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  exclusivity?: InputMaybe<Scalars['String']['input']>;
  headlinerGuarantee?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  merch?: InputMaybe<Scalars['String']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerExpirationDate?: InputMaybe<Scalars['String']['input']>;
  performanceDatesDescription?: InputMaybe<Scalars['String']['input']>;
  promoterName?: InputMaybe<Scalars['String']['input']>;
  promoterProfitPercentage?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  support?: InputMaybe<Scalars['String']['input']>;
  supportGuarantee?: InputMaybe<Scalars['Float']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateSheet. */
export type UpdateSheetPayload = {
  __typename?: 'UpdateSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpdateShoppingCart */
export type UpdateShoppingCartInput = {
  changes: ShoppingCartInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateShoppingCart. */
export type UpdateShoppingCartPayload = {
  __typename?: 'UpdateShoppingCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  shoppingCart: ShoppingCart;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertAgent */
export type UpsertAgentInput = {
  agencyName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertAgent. */
export type UpsertAgentPayload = {
  __typename?: 'UpsertAgentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertExpenseCategory */
export type UpsertExpenseCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertExpenseCategory. */
export type UpsertExpenseCategoryPayload = {
  __typename?: 'UpsertExpenseCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  expenseCategory?: Maybe<ExpenseCategory>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertExpense */
export type UpsertExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  calculationType?: InputMaybe<VariableExpenseEnum>;
  calculationValue?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expenseCategoryId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertExpense. */
export type UpsertExpensePayload = {
  __typename?: 'UpsertExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  expense?: Maybe<Expense>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertList */
export type UpsertListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gross?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listType: ListTypeEnum;
  name: Scalars['String']['input'];
  offerSheetId?: InputMaybe<Scalars['Int']['input']>;
  projected: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertList. */
export type UpsertListPayload = {
  __typename?: 'UpsertListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  list?: Maybe<List>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertOfferContact */
export type UpsertOfferContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offerSheetId: Scalars['Int']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertOfferContact. */
export type UpsertOfferContactPayload = {
  __typename?: 'UpsertOfferContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<OfferSheetContact>;
  contacts?: Maybe<Array<OfferSheetContact>>;
};

/** Autogenerated input type of UpsertTicket */
export type UpsertTicketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offerSheetId?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  projected: Scalars['Int']['input'];
  section: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertTicket. */
export type UpsertTicketPayload = {
  __typename?: 'UpsertTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
  ticket?: Maybe<OfferTicket>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UserAccount = {
  __typename?: 'UserAccount';
  id: Scalars['Int']['output'];
  teamRole?: Maybe<TeamRole>;
  user: User;
};

export type UserAccountAttributes = {
  accountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamRoleId: Scalars['Int']['input'];
  user?: InputMaybe<UserAttributes>;
};

/** UserAccountCollection type */
export type UserAccountCollection = {
  __typename?: 'UserAccountCollection';
  /** A collection of paginated UserAccountCollection */
  collection: Array<UserAccount>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type UserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ValidateNotABot */
export type ValidateNotABotInput = {
  checkbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponse: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateNotABot. */
export type ValidateNotABotPayload = {
  __typename?: 'ValidateNotABotPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notABotUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum VariableExpenseEnum {
  /** % of GBOR */
  GborPercentage = 'gbor_percentage',
  /** Per Attendee */
  PerAttendee = 'per_attendee',
  /** Per ticket */
  PerTicket = 'per_ticket'
}

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  includeCcFee?: Maybe<Scalars['Boolean']['output']>;
  includeConvenienceFee?: Maybe<Scalars['Boolean']['output']>;
  includeTaxFee?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Attachment>;
  logoId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `logo` instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  processingFeePercentage?: Maybe<Scalars['Float']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Array<VenueRoom>>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VenueAttributes = {
  address?: InputMaybe<AddressAttributes>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeCcFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeConvenienceFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeTaxFee?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  processingFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Array<VenueRoomAttributes>>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRoom = {
  __typename?: 'VenueRoom';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type VenueRoomAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VpError = {
  __typename?: 'VpError';
  /** Full error message */
  message: Scalars['String']['output'];
  /** Path to the field that caused the error, or `base` */
  path?: Maybe<Scalars['String']['output']>;
};

export type WhitelabelAttributes = {
  attachmentId?: InputMaybe<Scalars['Int']['input']>;
  checkoutUrlBase?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  landingUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WhitelabelConfig = {
  __typename?: 'WhitelabelConfig';
  attachment?: Maybe<Attachment>;
  checkoutUrlBase?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  fromEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  landingUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stripeApiKey?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
};

export type WidgetAttributes = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  loaderUrl: Scalars['String']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  configuration?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  loaderUrl?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** WidgetConfigCollection type */
export type WidgetConfigCollection = {
  __typename?: 'WidgetConfigCollection';
  /** A collection of paginated WidgetConfigCollection */
  collection: Array<WidgetConfig>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    